/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthScoreHistoryModel } from '../../models/health-score-history-model';
import { HealthScoreHistoryRequestModel } from '../../models/health-score-history-request-model';

export interface ProfileHealthScoreHistoryPost$Params {
      body?: HealthScoreHistoryRequestModel
}

export function profileHealthScoreHistoryPost(http: HttpClient, rootUrl: string, params?: ProfileHealthScoreHistoryPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<Array<HealthScoreHistoryModel>>> {
  const rb = new RequestBuilder(rootUrl, profileHealthScoreHistoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<Array<HealthScoreHistoryModel>>;
    })
  );
}

profileHealthScoreHistoryPost.PATH = '/Profile/HealthScoreHistory';
